import React, { memo } from 'react';

type Props = {
  className?: string;
};

const LimitedEditionLabel: React.FC<Props> = ({ className }) => (
  <div
    className={`tw-inline-block tw-w-fit tw-rounded-full tw-bg-orange-500 tw-px-3 tw-py-1 tw-text-xs tw-font-semibold tw-text-white ${
      className || ''
    }`}>
    Limited Edition
  </div>
);

export default memo(LimitedEditionLabel);
